/**
 * After a global Publish run, trigger content-engine → GitHub deploy for the CMS build's git branch.
 */
export type SnackbarLike = {
  open: (opts: { type: "success" | "error" | "warning" | "info"; message: string }) => void;
};

export async function triggerFrontendDeployAfterPublish(
  getAuthToken: () => Promise<string | null>,
  snackbar: SnackbarLike | undefined,
): Promise<void> {
  const contentEngineUrl = import.meta.env.VITE_CONTENT_ENGINE_URL?.replace(/\/$/, "");
  const branch = import.meta.env.VITE_DEPLOY_GIT_REF?.trim();
  if (!contentEngineUrl || !branch) {
    snackbar?.open({
      type: "warning",
      message:
        "Statuses updated. Frontend deploy was skipped: this CMS build has no content-engine URL or deploy branch. " +
        "Set GitHub Actions variable CONTENT_ENGINE_URL_DEV and build the CMS with deploy-cms (sets branch from git).",
    });
    return;
  }

  try {
    const idToken = await getAuthToken();
    if (!idToken?.trim()) {
      snackbar?.open({
        type: "error",
        message: "Statuses updated, but sign in again to start the frontend deploy.",
      });
      return;
    }
    const res = await fetch(`${contentEngineUrl}/deploy-frontend`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${idToken}` },
      body: JSON.stringify({ ref: branch }),
    });
    const data = (await res.json()) as { ok?: boolean; error?: string };
    if (!res.ok || !data.ok) {
      snackbar?.open({
        type: "error",
        message: data.error ?? "Statuses updated, but the frontend deploy could not be started. Run the workflow in GitHub.",
      });
    } else {
      snackbar?.open({
        type: "success",
        message: `Frontend deploy started for branch ${branch}.`,
      });
    }
  } catch {
    snackbar?.open({
      type: "error",
      message: "Statuses updated, but the deploy request failed. Check network or try again from GitHub Actions.",
    });
  }
}
